import { useQuery } from "@tanstack/react-query";
import { partnerApiService } from "@/services/partner-api.service";

export const useBillingSummary = () => {
	return useQuery({
		queryKey: ["partner", "billing", "summary"],
		queryFn: partnerApiService.getBillingSummary,
	});
};
